(function (globalScope, factory) {
  const api = factory();

  if (typeof module === 'object' && module.exports) module.exports = api;
  if (globalScope) globalScope.CernirCustomStrapAdditionalCustomisationData = api;
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  'use strict';

  const DATA = Object.freeze({
  "version": "demo-v1.0.0",
  "relatedImages": {
    "required": false,
    "acceptedExtensions": [
      "jpg",
      "jpeg",
      "png",
      "pdf"
    ],
    "maxFiles": 4,
    "maxMegabytesPerFile": 8
  },
  "personalisation": {
    "required": false,
    "maxCharacters": 10,
    "disallowOtherBrandNames": true,
    "hiddenForStyles": [
      "rally-small-holes",
      "rally-large-holes",
      "rally-hybrid"
    ]
  },
  "noCernirLogo": {
    "type": "boolean",
    "required": false,
    "default": false,
    "meaningWhenTrue": "omit CERNIR logo"
  }
});

  function fileExtension(file) {
    const name = typeof file?.name === 'string' ? file.name.trim().toLowerCase() : '';
    const dotIndex = name.lastIndexOf('.');
    return dotIndex > -1 ? name.slice(dotIndex + 1) : '';
  }

  function validateRelatedImages(files) {
    const list = Array.from(files || []);
    if (!list.length) return '';
    if (list.length > DATA.relatedImages.maxFiles) return `Upload no more than ${DATA.relatedImages.maxFiles} files.`;
    const invalidType = list.find((file) => !DATA.relatedImages.acceptedExtensions.includes(fileExtension(file)));
    if (invalidType) return `${invalidType.name || 'A selected file'} must be JPG, JPEG, PNG or PDF.`;
    const maxBytes = DATA.relatedImages.maxMegabytesPerFile * 1024 * 1024;
    const oversized = list.find((file) => !Number.isFinite(file?.size) || file.size > maxBytes);
    if (oversized) return `${oversized.name || 'A selected file'} must be ${DATA.relatedImages.maxMegabytesPerFile} MB or smaller.`;
    return '';
  }

  function isPersonalisationActive(style) {
    return !DATA.personalisation.hiddenForStyles.includes(style);
  }

  // The workshop stamps the standard English alphabet only. Accents are dropped (Nguyễn → Nguyen), curly quotes and
  // dashes become plain ones; any other script, emoji or symbol is refused.
  const STAMP_CHARACTERS = /^[A-Za-z0-9 .,;:'&!?-]*$/;

  function normalisePersonalisation(value) {
    return String(value ?? '').normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/đ/g, 'd').replace(/Đ/g, 'D')
      .replace(/[‘’ʼ]/g, "'").replace(/[–—]/g, '-');
  }

  function validatePersonalisation(value, style) {
    if (!isPersonalisationActive(style)) return '';
    const text = normalisePersonalisation(typeof value === 'string' ? value : '').trim();
    if (!STAMP_CHARACTERS.test(text)) {
      return "Use English letters A–Z, numbers, spaces and . , ; : ' & - ! ? only.";
    }
    if (text.length > DATA.personalisation.maxCharacters) {
      return `Personalisation must be ${DATA.personalisation.maxCharacters} characters or fewer.`;
    }
    return '';
  }

  return Object.freeze({ DATA, validateRelatedImages, isPersonalisationActive, normalisePersonalisation, validatePersonalisation });
});
